import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import en from '../i18n/vuetify/en'
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify, {
  lang: {
    locales: { en },
    current: 'en'
  },
  theme: {
    primary: '#0e76bc',
    secondary: '#f27421',
    light: '#ffd200'
  }
})
